var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_timeline",
    "data-name": "icona timeline",
    transform: "translate(-1183 -39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_timeline-2",
    "data-name": "icona timeline",
    transform: "translate(1184.8 39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(1.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1520",
    "data-name": "Raggruppa 1520",
    transform: "translate(7.38 3.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1519",
    "data-name": "Raggruppa 1519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_274",
    "data-name": "Tracciato 274",
    d: "M239.639,124.48l-2.231-1.673V119.4a.62.62,0,0,0-1.239,0v3.718a.618.618,0,0,0,.248.5l2.479,1.859a.62.62,0,0,0,.744-.992Z",
    transform: "translate(-236.169 -118.779)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1522",
    "data-name": "Raggruppa 1522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1521",
    "data-name": "Raggruppa 1521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_275",
    "data-name": "Tracciato 275",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0ZM8,14.761A6.761,6.761,0,1,1,14.761,8,6.769,6.769,0,0,1,8,14.761Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "timeline",
    transform: "translate(0 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_293",
    "data-name": "Tracciato 293",
    d: "M-24325.5,14582.5h13.832",
    transform: "translate(24328.5 -14579.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_35",
    "data-name": "Ellisse 35",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_36",
    "data-name": "Ellisse 36",
    transform: "translate(6.667)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_37",
    "data-name": "Ellisse 37",
    transform: "translate(13.333)",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_776",
    "data-name": "Rettangolo 776",
    transform: "translate(1183 39)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.c97f558f846d5e14a46174a0565cefdb.svg";
export { ForwardRef as ReactComponent };